import React from "react";

function BikKrdTooltip({children}) {
    return (
        <span className="bik-tooltip-wrapper">
            {children}
            <span className="bik-tooltip-icon" aria-label="Wyjaśnienie statusu BIK/KRD">?</span>
            <div className="bik-tooltip-content">
                <p>Status <strong>POZYTYWNY</strong> oznacza, że nie posiadasz żadnych zaległości w spłacie kredytów lub
                    innych zobowiązań gospodarczych;<br/> <strong>NEGATYWNY</strong> - występują zaległości w
                    spłatach; <br/><strong>NIEZNANY</strong> - nie jestem pewny/a czy występują zaległości w spłatach</p>
            </div>
        </span>
    );
}

export default BikKrdTooltip;
